import React, { useState } from 'react';
import PrintModal from 'components/photos/PrintModal';

const NO_ACTION = null;
const NO_MODAL = () => {};
const EMPTY_RESULT = [NO_ACTION, NO_MODAL];

const databaseIdFrom = (obj) => parseInt(obj.databaseId, 10);

export default function useMenuActionPrint({ assets, assetsByType }) {
  const [modalVisible, setModalVisible] = useState(false);

  const hasPermission = true;
  const validSelection =
    assets.length > 0 && assets.length === assetsByType.photos.length;

  if (!hasPermission || !validSelection) {
    return EMPTY_RESULT;
  }

  const action = () => {
    setModalVisible(true);
  };

  const renderModal = () =>
    !modalVisible ? null : (
      <PrintModal
        isOpen={modalVisible}
        photos={assets.map(databaseIdFrom)}
        onRequestClose={() => {
          setModalVisible(false);
        }}
      />
    );

  return [action, renderModal];
}
